import { defineEvent } from '../types/event';
export var PRODUCT_CARD_CAROUSEL_CHANGE = defineEvent({
    platforms: [
        {
            name: 'Optimizely',
            transform: function (input) { return ({
                eventName: 'image_carousel__slide_selector_click',
                index: input.index
            }); }
        },
        {
            name: 'Heap',
            transform: function (input) { return ({
                eventName: 'productCard_carouselIndicator',
                productCard_title: input.title
            }); }
        }
    ]
});
